import type { IconProps } from './types';

export const FlagIcon = (props: IconProps) => {
  const {
    width = 16,
    height = 18,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 18"
      fill="none"
      className={className}
    >
      <path
        d="M1.32141 1.10714V16.8929"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6786 10.8214H1.32141V1.10714H14.6786L11.0357 5.96429L14.6786 10.8214Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
